<template>
    <div class="series-course-wrapper">
        <ctl-header title="系列课程" :onBack="onBack" v-if="!H5">
            <div class="header-button" slot="right">
                <img class="share" @click="openSharePanel" src="@/assets/public/icon_fx01.png" alt="">
                <img class="customer" @click="callPhone" src="@/assets/vip/icon_customerservice1.png" alt="">
            </div>
        </ctl-header>

        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="main">
                <div class="cover">
                    <img :src="detailData.picture" alt="">
                </div>
                <div class="info">
                    <div class="name">{{ detailData.courseName }}</div>
                    <div :class="['brief' , !briefMore && 'show-ellipsis']">{{ detailData.introduce }}</div>
                    <div class="other">
                        <div class="watch"><van-icon size="17" name="eye-o" />{{ detailData.viewCount }}</div>
                        <div v-if="detailData.introduce && detailData.introduce.length > 52" class="more" @click="briefMore = !briefMore">{{briefMore ? '收起' : '更多'}}<van-icon size="12" :name="briefMore ? 'arrow-up' : 'arrow-down'" /></div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="section-title">
                    <img src="@/assets/microCourse/xlkc_bhkc.png" alt="">
                </div>
                <div class="course-list">
                    <div class="course-list-title">共{{detailData.courseListUnderSeries.length}}门课程</div>
                    <div class="card" v-for="(v,i) in detailData.courseListUnderSeries" :key="i" @click="goCourse(v)">
                        <div class="card-cover">
                            <img :src="v.picture" alt="">
                        </div>
                        <div class="card-info">
                            <div class="name show-ellipsis">{{v.courseName}}</div>
                            <div class="other">
                                <div class="price">{{ v.payConPrice ?  `¥${v.payConPrice ? v.payConPrice : v.payOrigPrice}`: '免费' }}</div>
                                <div class="watch"><van-icon size="16" name="eye-o" />
                                    {{ v.viewCount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section detail">
                <div class="section-title">
                    <img src="@/assets/microCourse/xlkc_kcxq.png" alt="">
                </div>
                <div class="detail-content" v-html="detailData.details"></div>
            </div>
            <div class="section question" v-if="detailData.chargingFlag && !detailData.buyFlag">
                <div class="section-title">
                    <img src="@/assets/microCourse/xlkc_cjwt.png" alt="">
                </div>
                <div class="question-content">
                    <div class="item">
                        <p class="p1">1、付费课程有效期多久？</p>
                        <p class="p2">本产品有效期从您购买之日算起，有效期<b>{{ detailData.effectiveDays }}</b>天</p>
                    </div>
                    <div class="item">
                        <p class="p1">2、购买后可以退款吗？</p>
                        <p class="p2">课程为虚拟商品，不支持退款哦！</p>
                    </div>
                    <div class="item">
                        <p class="p1">3、课程可以回看吗？</p>
                        <p class="p2">有效期内可无限次观看回放。</p>
                    </div>
                    <div class="item">
                        <p class="p1">4、其他问题及注意事项</p>
                        <p class="p2">可在【我的】页面找在线客服咨询，或在【意见反馈】中留言，我们会及时为您解答。</p>
                    </div>
                </div>
            </div>
            <div class="section server" v-if="detailData.chargingFlag && detailData.buyFlag">
                <div class="section-title">
                    <img src="@/assets/microCourse/xlkc_fwsm.png" alt="">
                </div>
                <div class="server-content">
                    <p class="p1">1、感谢您购买该课程，购买后即可生效。</p>
                    <p class="p1">2、课程为虚拟商品，不支持退款。</p>
                    <p class="p1">3、如有疑问，请联系斑斑客服。</p>
                </div>
            </div>
            <div class="footer" v-if="detailData.chargingFlag && !detailData.buyFlag">
                <div class="fixed">
                    <div class="price">
                        <span class="f1">¥{{detailData.payConPrice ? detailData.payConPrice : detailData.payOrigPrice}}</span>
                        <span class="f2">{{detailData.effectiveDays === 365 ? `/年` : `/${detailData.effectiveDays}天`}}</span>
                        <span class="f3" v-if="detailData.payOrigPrice">¥{{detailData.payOrigPrice}}</span>
                    </div>
                    <div class="submit" @click="getOpenSeriesPopCourseList">立即开通</div>
                </div>
            </div>
        </share-ad>

        <van-popup
            v-model="submitVisible"
            close-icon="close"
            position="bottom"
            :class="['submit-popup-wrapper']"
            :style="{ height: '60%' }"
        >
            <div class="popup-header">
                <span class="title">选择开通课程</span>
                <span @click="submitVisible = false" class="close"><img src="@/assets/microCourse/close.png" alt=""></span>
            </div>
            <div class="popup-list">
                <div :class="['card',formData.courseId === courseId && 'active' , submitDisable && 'disabled']" @click="formData.courseId = courseId">
                    <div class="card-head">
                        <div class="name">{{ openData.courseName }}</div>
                        <div class="price">
                            <template>
                                <span class="f1">¥{{openData.payConPrice ? openData.payConPrice : openData.payOrigPrice }}</span>
                                <span class="f3" v-if="openData.payOrigPrice">¥{{ openData.payOrigPrice }}</span>
                            </template>
                        </div>
                    </div>
                    <div class="scroll">
                        <div class="child">
                            <div :class="['child-card']" v-for="(v,i) in openData.subCourseList" :key="i">
                                <p class="p1">{{ v.courseName }}</p>
                                <p class="p2" v-if="v.chargingFlag">单卖 <b class="f1">¥ {{v.payConPrice ? v.payConPrice : v.payOrigPrice }}</b><b v-if="v.payOrigPrice" class="f2">¥{{v.payOrigPrice}}</b></p>
                                <p class="p2" v-else>免费</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['card',formData.courseId === v.courseId && 'active',v.buyFlag && 'open',v.buyFlag && 'disabled']" v-for="(v,i) in openData.subCourseList" :key="i" @click="formData.courseId = v.courseId">
                    <div class="card-head">
                        <div class="name">{{ v.courseName }}</div>
                        <div class="price">
                            <template v-if="v.chargingFlag">
                                <span class="f1">¥{{v.payConPrice ? v.payConPrice : v.payOrigPrice}}</span>
                                <span class="f3" v-if="v.payOrigPrice">¥{{v.payOrigPrice}}</span>
                            </template>
                            <span v-else class="f4">免费</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="['popup-submit',(selectChildData.courseId[formData.courseId].buyFlag || (formData.courseId === courseId) && submitDisable) && 'disabled']" v-if="formData.courseId" @click="submit">
                <span v-if="formData.courseId === courseId && submitDisable" class="f4">不可购买</span>
                <template v-else-if="(selectChildData.courseId[formData.courseId].chargingFlag && !selectChildData.courseId[formData.courseId].buyFlag)">
                    <span class="f1">¥{{selectChildData.courseId[formData.courseId].payConPrice ? selectChildData.courseId[formData.courseId].payConPrice : selectChildData.courseId[formData.courseId].payOrigPrice}}</span>
                    <span class="f2"></span>
                    <span class="f3">立即开通</span>
                </template>
                <span v-else class="f4">{{ (selectChildData.courseId[formData.courseId].buyFlag || (formData.courseId === courseId && submitDisable)) ? '不可购买' : '免费学习'}}</span>
            </div>
        </van-popup>
        <ctl-dialog v-model="dialogData" :loading="loading"/>
    </div>
</template>

<script>
import { Button, List, PullRefresh, Tab, Tabs, Toast, Icon, Popup } from 'vant'
export default {
    components: {
        [List.name]: List,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Popup.name]: Popup,
        [Button.name]: Button,
        [Toast.name]: Toast,
        [Icon.name]: Icon,
        [PullRefresh.name]: PullRefresh
    },
    name: 'seriesCourse',
    data () {
        return {
            courseId: {},
            cityCode: '',
            source: '',
            H5: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            formData: {
                courseId: ''
            },
            shareData: {},
            briefMore: false,
            submitVisible: false,
            submitDisable: false,
            loading: false,
            detailData: {
                courseListUnderSeries: []
            },
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            openData: {},
            selectChildData: {
                courseId: {}
            }
        }
    },
    created () {
        // 设置基础数据
        let { id, cityCode, shareType, appType, source } = this.$route.query
        this.courseId = id
        this.source = source
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || cityCode
        this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof appType === 'object' ? appType[0] : appType)

        this.H5 = shareType === 'h5'
        this.getDetail()
        this.getSetting()

        // 暴露刷新页面方法
        this.$jsBridge.registerHandler('refreshCallBack', () => {
            // 注入token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
            this.getDetail()
        })
    },
    methods: {
        onBack () {
            if (this.source === 'app') {
                this.$jsBridge.callBackHandler('returnLastPage')
                return
            }
            this.$router.back()
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 跳转单课
        goCourse (v) {
            if (this.H5) {
                this.linkApp()
                return
            }
            let courseId = v.courseId
            let coverUrl = v.picture
            let courseName = v.courseName
            let seriesCourseId = this.courseId
            this.$jsBridge.callBackHandler('pushMicroCourseVideoDetailPage', { seriesCourseId, courseId, coverUrl, courseName })
        },
        // 跳转提交开通页面
        submit () {
            if (this.H5) {
                this.linkApp()
                return
            }
            if (((this.formData.courseId === this.courseId) && this.submitDisable) || this.selectChildData.courseId[this.formData.courseId].buyFlag) {
                return
            }

            if (this.selectChildData.courseId[this.formData.courseId].chargingFlag) {
                this.$router.push({ name: 'microCourseSubmit', query: { id: this.formData.courseId, source: this.source } })
            } else {
                this.goCourse(this.selectChildData.courseId[this.formData.courseId])
            }
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || this.detailData.courseName
            // 内容
            let content = this.shareData.shareContent || this.detailData.introduce
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'microcourse-details'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?id=${this.courseId}&shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || this.detailData.picture
            }

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 联系客服
        callPhone () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 获取数据
        getDetail () {
            let postData = {
                courseId: this.courseId,
                cityCode: this.cityCode
            }
            this.$api.getCourseDetail(postData).then(res => {
                if (res.status) {
                    this.detailData = res.result
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取开通数据
        getOpenSeriesPopCourseList () {
            if (this.H5) {
                this.linkApp()
                return
            }
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')
            userInfo = userInfo ? JSON.parse(userInfo) : {}
            // 没有用户id && 去登录
            if (!userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }
            let postData = {
                courseId: this.courseId,
                cityCode: this.cityCode
            }
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.getOpenSeriesPopCourseList(postData).then(res => {
                Toast.clear()
                if (res.status) {
                    this.submitVisible = true
                    this.openData = res.result
                    // 设置默认数据
                    this.formData.courseId = this.courseId
                    this.selectChildData.courseId[this.courseId] = this.detailData
                    this.openData.subCourseList.forEach(v => {
                        this.selectChildData.courseId[v.courseId] = v
                        if (v.buyFlag) {
                            this.submitDisable = true
                        }
                    })
                } else {
                    Toast(res.message)
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            return this.$api.getAdSetting({ code: 'microcourse-details' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.show-ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
.submit-popup-wrapper{
    display: flex;
    flex-direction: column;
    .popup-header{
        margin: 9px 0 0 0;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 1;
        .title{
            font-size: 18px;
            color: #333333;
        }
        .close{
            font-size: 0;
            img{
                width: 12px;
                height: 12px;
            }
        }
    }
    .popup-list{
        flex: 1;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        padding: 0 10px;
        margin: 5px 0 0 0;
        .card{
            margin: 10px 0 0  0;
            padding: 16px 13px;
            border-radius: 5px;
            border: 1px solid #A86F2F;
            .card-head{
                display: flex;
                align-items: center;
                line-height: 1;
                justify-content: space-between;
                color: #A86F2F;
                .name{
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-size: 18px;
                    font-weight: 600;
                }
                .price{
                    font-size: 12px;
                    .f1,.f4{
                        font-size: 15px;
                    }
                    .f3{
                        margin: 0 0 0 5px;
                        text-decoration: line-through;
                    }
                }
            }
        }
        .card.active{
            position: relative;
            border: 1px solid #212528;
            background: linear-gradient(90deg, #3A3D3F 0%, #212528 100%);
            .card-head{
                color: #F0D9BF;
            }
            &::after{
                content:'';
                position: absolute;
                top: -1px;
                right: -1px;
                width: 32px;
                height: 16px;
                background: url("~@/assets/microCourse/bq_yx.png");
                background-size: 100% 100%;
            }
        }
        .card.open{
            position: relative;
            &::before{
                content:'';
                position: absolute;
                top: -1px;
                left: -1px;
                width: 44px;
                height: 16px;
                background: url("~@/assets/microCourse/bq_kt.png");
                background-size: 100% 100%;
            }
        }
    }
    .scroll{
        margin: 15px 0 0 0;
        overflow: hidden;
        height: 59px;
        .child{
            overflow: auto;
            white-space: nowrap;
            height: 59px;
            padding: 0 0 10px 0;
        }
        .child-card{
            line-height: 1;
            box-sizing: border-box;
            padding: 0 8px;
            margin: 0 10px 0 0;
            display: inline-block;
            width: 146px;
            height: 59px;
            background: linear-gradient(180deg, #FEF4E8 0%, #FFF1E1 100%);
            border-radius: 5px;
            .p1{
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 12px 0 0 0;
                font-size: 13px;
                font-weight: 600;
                color: #A86F2F;
            }
            .p2{
                margin: 8px 0 0 0;
                font-size: 12px;
                color: #A86F2F;
                transform: scale(0.9);
                transform-origin: left top;
                .f1{
                    font-weight: normal;
                }
                .f2{
                    display: inline-block;
                    text-decoration: line-through;
                    font-weight: normal;
                    margin: 0 0 0 2px;
                    transform: scale(0.9);
                    transform-origin: left bottom;
                }
            }
        }
    }
    .popup-submit{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px auto;
        width: 355px;
        height: 45px;
        background: #F5DDB6;
        border-radius: 23px;
        line-height: 1;
        .f1{
            font-size: 24px;
            font-weight: 600;
            color: #A86F2F;
        }
        .f2{
            margin: 0 4px;
            width: 1px;
            height: 20px;
            background: #D5B28A;
        }
        .f3,.f4{
            font-size: 18px;
            font-weight: 600;
            color: #A86F2F;
        }
    }

}
.card.disabled{
    border: 1px solid #DBDBDB !important;
    background: #FFFFFF !important;;
}

.disabled{
    .card-head{
        color: #999999 !important;;
    }
    .p1,.p2{
        color: #999999 !important;
    }
    .child-card{
        background: #F5F5F5 !important;

    }
}
.disabled.active::after{
    background: url("~@/assets/microCourse/bq_yxt.png") !important;
    background-size: 100% 100% !important;
}

.popup-submit.disabled{
    background: #999999;
    .f4{
        color: #FFFFFF;
    }
}
.series-course-wrapper{
    /deep/{
        .mask,.dialog-content{
            z-index: 99999;
        }
    }
    .header-button{
        display: flex;
        align-items: center;
        .share,.customer{
            height: 25px;
        }
        .share{
            margin: 0 15px 0 0;
        }
    }
    .main{
        background: #ffffff;
        .cover{
            font-size: 0;
            width: 375px;
            height: 210px;
            background: #000000;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .info{
            line-height: 1;
            padding: 15px;
            .name{
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
            .brief{
                margin: 12px 0 0 0;
                font-size: 13px;
                color: #666666;
                line-height: 24px;
            }
            .other{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0 0 0;
                font-size: 13px;
                color: #999999;
                .watch,.more{
                    display: flex;
                    align-items: center;
                }
                .watch .van-icon{
                    line-height: 0;
                    margin: 0 5px 0 0;
                }
                .more .van-icon{
                    margin: 0 0 0 5px;
                }
            }
        }
    }
    .section{
        padding: 0 10px;
        background: #fafafa;
        .section-title{
            padding: 5px 0 8px 0;
            font-size: 0;
            text-align: center;
            img{
                width: 160px;
            }
        }
        .course-list{
            background: #FFFFFF;
            box-shadow: 0 0 5px 0 rgba(0,0,0,0.05);
            border-radius: 5px;
            .course-list-title{
                padding: 0 0 0 35px;
                line-height: 36px;
                font-size: 16px;
                color: #FFFFFF;
                background: url("~@/assets/microCourse/xlkc_bhkcfbt.png") no-repeat left 100%;
                background-size: 315px 36px;
            }
            .card{
                padding: 16px 0;
                margin: 0 auto;
                width: 325px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #eeeeee;
                .card-cover{
                    width: 155px;
                    height: 100px;
                    background: #000000;
                    border-radius: 5px;
                    overflow: hidden;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .card-info{
                    flex: 1;
                    margin: 0 0 0 6px;
                    line-height: 1;
                    height: 70px;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    .name{
                        line-height: 18px;
                        font-size: 15px;
                        color: #333333;
                    }
                    .other{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .price{
                            font-size: 13px;
                            color: #FF5050;
                        }
                        .watch{
                            display: flex;
                            align-items: center;
                            font-size: 13px;
                            color: #999999;
                            .van-icon{
                                margin: 0 3px 0 0;
                            }
                        }
                    }
                }
            }
            .card:last-child{
                border: 0;
            }
        }
    }
    .detail{
        padding: 0;
        .detail-content{
            background: #ffffff;
            padding: 10px;
            /deep/ img{
                width: 100% !important;
            }
        }
    }
    .question{
        padding: 0;
        .question-content{
            background: #ffffff;
            padding: 9px 15px 14px 15px;
            line-height: 1;
            .item{
                margin: 0 0 20px 0;
            }
            .item:last-child{
                margin: 0;
            }
            .p1{
                font-size: 15px;
                color: #333333;
            }
            .p2{
                margin: 7px 0 0 0;
                font-size: 13px;
                line-height: 18px;
                color: #999999;
                b{
                    font-weight: normal;
                    color: #FF5050;
                }
            }
            .p3{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p3:last-child{
                margin: 0;
            }
        }
    }
    .server{
        padding: 0;
        .server-content{
            background: #ffffff;
            padding: 12px 15px;
            line-height: 1;
            .p1{
                font-size: 15px;
                color: #333333;
                margin: 0 0 15px 0;
            }
            .p1:last-child{
                margin: 0;
            }
        }
    }
    .footer{
        height: 50px;
        .fixed{
            box-sizing: border-box;
            display: flex;
            align-items: center;
            position: fixed;
            bottom:0;
            left: 0;
            right: 0;
            border-top: 1px solid #eeeeee;
            height: 50px;
            background: #FFFFFF;
        }
        .price{
            text-align: center;
            flex: 1;
            .f1{
                font-size: 24px;
                font-weight: 600;
                color: #FF5050;
            }
            .f2{
                font-size: 15px;
                color: #333333;
            }
            .f3{
                text-decoration:line-through;
                margin: 0 0 0 5px;
                font-size: 15px;
                color: #999999;
            }
        }
        .submit{
            text-align: center;
            line-height: 50px;
            width: 120px;
            background: #F5DDB6;
            font-size: 18px;
            font-weight: 600;
            color: #A86F2F;
        }
    }
}
</style>
